/**
 * Compares two maps with json objects for equality.
 * @param a The first map to compare.
 * @param b The second map to compare.
 * @returns True if the maps are equal, false otherwise.
 */
export function areMapsEqual<T extends Record<string, any>>(
  a: Record<string, T>,
  b: Record<string, T>,
): boolean {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key)) return false;

    const objA = a[key];
    const objB = b[key];

    // shallow compare all fields
    for (const prop in objA) {
      if (objA[prop] !== objB[prop]) {
        return false;
      }
    }
  }

  return true;
}
